@if (selected(); as banner) {
  <div class="super-banner">
    <button mat-icon-button
            class="super-banner-toggle"
            [class.hidden-position]="hidden()"
            (click)="toggleBanner()">
      <mat-icon fontSet="material-symbols-outlined">{{ hidden() ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="banner-wrapper"
         data-track-content
         data-content-name="Sticky banner"
         [@slideUpDown]="hidden() ? 'hidden' : 'visible'">
      <a [href]="banner.link || null"
         [target]="banner.link ? banner.target : null"
         [class.no-link]="!banner.link">

        <img [src]="PHXCDN + '/marketing-management/' + banner.image"
             [alt]="banner.title || 'Sticky Banner'"
             class="super-banner-image"
             data-content-piece
             loading="eager">
      </a>
    </div>
  </div>
}

